import { render, staticRenderFns } from "./TableCellTypeInternalLink.vue?vue&type=template&id=5a7298dc&scoped=true"
import script from "./TableCellTypeInternalLink.vue?vue&type=script&lang=js"
export * from "./TableCellTypeInternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7298dc",
  null
  
)

export default component.exports